export default "__VITE_PUBLIC_ASSET__14e5abf7__"